const displayNamesForNewSubmitApi = {
    "SOMAIN_INDENT" : true,
    "SOMAIN_ORDER" : true,
    "SOMAIN_PROCESSED" : true,
    "SOMAIN_REJECTED" : true,
    
    // Orders Section : 
    "ENT_PENDING_ALL" : true,
    "ENT_CONFIRMED_VENDOR" : true,
    "ENT_REJECTED_VENDOR" : true,
    "ENT_PROCESSED_ALL" : true,
    "ENT_CANCELLED_ALL" : true,
    VENDOR_CANCELLED_ALL: true,

    // Inspection : 
    "ENT_PENDING_QC" : true,
    "ENT_PENDING_QC_CONFIRM" : true,
    "ENT_INSPECTION_CANCELLED_ALL" : true,
    "ENT_PENDING_INSPECTION_WAREHOUSE" : true,
    "ENT_PENDING_QC_FAILED" : true,
    "ENT_PENDING_QC_RE_INSPECTION" : true,
    "ENT_PENDING_QC_COMPLETED" : true,

    // Delivery Challan
    "DELIVERY_CHALLAN_APPROVED" : true,
    "DELIVERY_CHALLAN_PENDING" : true,
    "DELIVERY_CHALLAN_REJECTED" : true,

    // Items
    "MANAGE_ITEMS_ALL" : true,    

    // Vendors
    // "MANAGE_VENDOR_ALL" : true,
    // "MANAGE_VENDOR_INACTIVE" : true,
    // "VENODR_PENDING_SIGN_UP" : true,  
    // "EMAIL_NOT_VERIFIED_VENDOR" : true,
    // "VENDOR_REQUESTED" : true,

    
    // Purchase Invoice 
    "ENT_PURCHASE_INVOICE_BOOKED": true,
    "ENT_PURCHASE_INVOICE_PENDING_GRC": true,
    "VENDOR_PURCHASE_INVOICE_BOOKED": true,
    "VENDOR_PURCHASE_INVOICE_PENDING_GRC": true,

    // Replenishment History
    "REPLENISHMENT_HISTORY" : true,
    
    // Master Data 
    "AGENT_MASTER_ALL": true,
    "AGENT_MASTER_INACTIVE": true,
    // "MATERIAL_LIBRARY_MASTER": true,
    "MANAGE_TRANSPORTER_ALL": true,
    "FABRIC_MASTER": true,
    "MANAGE_CUSTOMERS_ACTIVE": true,
    "MANAGE_CUSTOMER_INACTIVE": true,
    "MANAGE_CUSTOMERS_PENDING": true,
    "MANAGE_SALES_CUSTOMER": true,

    // Custom Data Upload 
    "VEND_CUSTOM_DATA": true,

    // For Manage Descrepancies
    "ENT_DEBIT_NOTE_DATA" : true,
    "ENT_DISCREPANCY_DETAILS" : true,
    "VEND_DEBIT_NOTE_DATA" : true,
    "VEND_DISCREPANCY_DETAILS" : true,
    
    // Open PO Vendor Side
    "VENDOR_PENDING_ALL" : true,
    "VENDOR_PENDING_APPROVAL_ALL" : true,
    "VENDOR_REJECTED_ALL" : true,

    // LR Processing Retailer and Vendor
    ENT_LR_PROCESSING_ALL: true,
    ENT_LR_PROCESSING_PEN_APPROVAL: true,
    ENT_LR_PROCESSING_APPT_PEN: true,
    // ENT_INTRANSIT_PENDING_TRANSPORTER: true,
    VENDOR_LR_PROCESSING_ALL: true,
    VENDOR_LR_PROCESSING_PEN_APPROVAL: true,
    VENDOR_LR_PROCESSING_APPT_PEN: true,
    // VENDOR_INTRANSIT_PENDING_TRANSPORTER: true,
    
    // Goods In Transit
    ENT_LR_INTRANSIT_ALL: true,
    ENT_LR_INTRANSIT_CANCELLED: true,
    ENT_INTRANSIT_APPT_PENDING: true,
    // Vendor Side
    VENDOR_LR_INTRANSIT_ALL: true,
    VENDOR_INTRANSIT_APPT_PENDING: true,

    // Event Mapping
    ENT_EVENT_MASTER_ALL: true,

    // Season Mapping
    SEASON_MASTER: true,

    // Shipment Retailer and Vendor
    ENT_ASN_APPROVAL_ALL: true,
    ENT_ASN_APPROVED_ALL: true,
    ENT_ASN_CANCELLED_ALL: true,
    VENDOR_ASN_APPROVAL_ALL: true,
    VENDOR_ASN_APPROVED_ALL: true,
    VENDOR_ASN_CANCELLED_ALL: true,
    VENDOR_PROCESSED_ALL : true,

    // Vendor Sale Indent
    // VENDOR_PI_TABLE_HEADER_MAIN: true,
    // VENDOR_PI_TABLE_HEADER_PENDING: true,
    // VENDOR_PI_TABLE_HEADER_APPROVED: true,
    // VENDOR_PI_TABLE_HEADER_DET: true,

    // Otb Plan 
    MANAGE_OTB_PLAN: true,
    MANAGE_OTB_PLAN_CONSOLIDATED: true,

    // MRP Range
    ITEM_HIERARCHY: true,

    // Auto ASN 
    AUTO_ASN_CONFIG: true,

    // Fabric Nomination
    FABRIC_NOMINATION: true,

    // Fabric Consumption Log
    FABRIC_NOMINATION_LOG: true,
    // Site to site mapping
    PLANNING_SETTINGS_SITETOSITE_MAPPING: true,
    "REPLENISHMENT_REQUIREMENT_SUMMARY" : true,
    "REPLENISHMENT_ALLOCATION_SUMMARY" : true,
    "REPLENISHMENT_PRODUCT_SUMMARY" : true,
    "REPLENISHMENT_STORE_SUMMARY" : true,
    "REPLENISHMENT_REQUIREMENT_SUMMARY_DETAIL" : true,
    "REPLENISHMENT_ALLOCATION_SUMMARY_DETAIL" : true,

    // Manage Costsheet
    "COST_SHEET_MAIN" : true,
    "MATERIAL_LIBRARY_MASTER" : true,

    // View Indent 
    PI_TABLE_HEADER_MAIN: true,
    PI_TABLE_HEADER_PENDING: true,
    PI_TABLE_HEADER_APPROVED: true,
    PI_TABLE_HEADER_DET: true,
    
    PLANNING_SETTINGS_ASSORTMENT: true,
    SIZE_ASSORTMENT_MBQ: true,
    CATEGORY_SIZE_MBQ: true,

    ARTICLE_ATTRIBUTE_MAPPING: true,
    DEPARTMENT_ARTICLE_PLAN: true,

    // API LOGS
    "ADM_API_LOG_HISTORY" : true,

    // System Mails
    "ADMIN_SYSTEM_MAIL_TABLE" : true,

    // User Data Mapping
    "USER_MAPPING_DATA" : true,

    // Manage Users
    "MANAGE_USERS" : true,
    
    "APPOINTMENT_SITE_DETAIL_LOGS":true,
    "APPOINTMENT_SITE_LOGS" : true,

    ENT_DOCUMENT_VIEWER_PO: true,
    VENDOR_DOCUMENT_VIEWER_PO: true,
    ENT_DOCUMENT_VIEWER_ASN: true,
    VENDOR_DOCUMENT_VIEWER_ASN: true,
    
    CUSTOMER_LEDGER: true,

    PRODUCT_SURVEY_DELIVERED: true,
    PRODUCT_SURVEY_OPENED: true,
    PRODUCT_SURVEY_UN_DELIVERED: true,
    PRODUCT_SURVEY_SUBMITTED: true,
    GET_ALL_SURVEY: true,

    PO_EXCEL_TABLE_HEADER: true,

    MANAGE_SALES_AGENT: true,

    ENT_BILL_DISCOUNTING: true,
    ENT_PAYMENT_REQ_COMPLETE: true,
    BILL_DISCOUNTING: true,
    VENDOR_PAYMENT_REQ_COMPLETE: true,
    
    ENT_INSPECTION_REPORT_DETAIL : true,
    VENDOR_INSPECTION_REPORT_DETAIL : true,

    BEST_SELLING_PRODUCT: true,
    TNA_REPORT_DETAIL : true,

    // View Order
    PO_TABLE_HEADER_MAIN: true,
    PO_TABLE_HEADER_PENDING: true,
    PO_TABLE_HEADER_APPROVED: true,
    PO_TABLE_HEADER_DET: true,
    ENT_EXPIRED_PO_ALL: true,

    DEPARTMENT_MAPPING: true,

    CUSTOM_SALES_GRC_REPORT: true,
    VENDOR_CUSTOM_SALES_GRC_REPORT: true,
    ENT_SALES_COGS_REPORT: true,

    MANAGE_OTB_PLAN: true,
    MANAGE_OTB_PLAN_CONSOLIDATED: true,
    MANAGE_OTB_PLAN_PENDING: true,
    OTB_MONITOR: true,
    
    AD_HOC_REQUEST_PENDING: true,
    AD_HOC_REQUEST_APPROVED: true,
    AD_HOC_REQUEST_REJECTED: true,
    
    // Early Payment Request
    ENT_ALL_INVOICE_PAYMENT_REQUEST: true,
    ENT_INVOICE_PAYMENT_REQUEST_PENDING: true,
    ENT_INVOICE_PAYMENT_REQUEST_CONFIRMED: true,
    ENT_INVOICE_PAYMENT_REQUEST_APPROVED: true,
    ENT_INVOICE_PAYMENT_REQUEST_REJECTED: true,
    VENDOR_PENDING_INVOICES: true,
    VEN_INVOICE_PAYMENT_REQUEST_PENDING: true,
    VEN_INVOICE_PAYMENT_REQUEST_CONFIRMED: true,
    VEN_INVOICE_PAYMENT_REQUEST_APPROVED: true,
    VEN_INVOICE_PAYMENT_REQUEST_REJECTED: true,


    //TRF
    ENT_TRF_DATA:true,
    VENDOR_TRF_DATA:true,

    // RTV 
    ENT_RTV_REQUEST_ALL: true,
    ENT_RTV_REQUEST_PENDING: true,
    ENT_RTV_REQUEST_ACCEPTED: true,
    ENT_RTV_REQUEST_INTRANSIT: true,
    ENT_RTV_REQUEST_RECEIVED: true,

    VEN_RTV_REQUEST_ALL: true,
    VEN_RTV_REQUEST_ACCEPTED: true,
    VEN_RTV_REQUEST_INTRANSIT: true,
    VEN_RTV_REQUEST_RECEIVED: true,

    VENDOR_PI_TABLE_HEADER_PENDING:true,
    VENDOR_PI_TABLE_HEADER_MAIN:true,
    VENDOR_PI_TABLE_HEADER_APPROVED: true,
    VENDOR_PI_TABLE_HEADER_DET: true,


    // Service Order
    ENT_SERVICE_ORDER: true,
    ENT_SERVICE_ORDER_PENDING: true,
    ENT_SERVICE_ORDER_CONFIRMED: true,
    ENT_SERVICE_ORDER_PARTIAL: true,
    ENT_SERVICE_ORDER_CLOSED: true,
    ENT_SERVICE_ORDER_REJECTED: true,

    VENDOR_SERVICE_ORDER: true,
    VENDOR_SERVICE_ORDER_PENDING: true,
    VENDOR_SERVICE_ORDER_CONFIRMED: true,
    VENDOR_SERVICE_ORDER_PARTIAL: true,
    VENDOR_SERVICE_ORDER_CLOSED: true,
    VENDOR_SERVICE_ORDER_REJECTED: true,

    // Manage Roles
    ROLES_ACCESS: true,

    DOCUMENT_ERROR: true,

    ENT_SALES_REPORT: true,
    VENDOR_SALES_REPORT: true,

    MANAGE_OTB_LEDGER: true,
    CHANNEL_WISE_DAILY_SALES_REPORT: true,

    // Otb Plan OTB Plan(Tab)
    OTB_PLAN_DETAILS: true,

    ENT_GRIEVANCE: true,
    VENDOR_GRIEVANCE: true,
    CUSTOM_AGING_REPORT: true,

    ENT_LR_GRC_ALL: true,

    ENT_GATE_ENTRY_ALL: true,
    ENT_PARTIAL_GRC_ALL: true,
    VENDOR_LR_GRC_ALL: true,
    VENDOR_GATE_ENTRY_ALL: true,

    ENT_LR_DELIVERED_PARTIAL_ALL: true,
    ENT_LR_DELIVERED_ALL: true,
    VENDOR_GATE_ENTRY_NOT_RECEIVED: true,

    ABC_ASSORTMENT_ANALYSIS: true,
    FRESH_DISCOUNTED_STOCK_PERFORMANCE: true,

    // Item Master Adam Sons
    ADAMSON_MANAGE_ITEMS_ALL: true,
    
    CUSTOM_SALES_GRC_REPORT: true,
    VENDOR_CUSTOM_SALES_GRC_REPORT: true,

    ENT_SALE_THROUGH_REPORT: true,
    CUSTOM_STOCK_POINT_DATA: true,
    CUSTOM_PENDING_PURCHASE_ORDERS: true,
    GET_CATEGORY_DESCRIPTION: true,
    MANAGE_LOG_REPORT: true,
    SM_HSN_MASTER: true,
    SM_ITEM_HIERARCHY_MASTER: true,
    SM_MARGIN_RULE_MASTER: true,
    SM_ARTICLE_MASTER: true,
}
export {displayNamesForNewSubmitApi}